"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../../");
var context_1 = require("../../../../context");
var enums_1 = require("../../../../types/enums");
var options = [
    'applied_during_session',
    'partial_application',
    'will_apply',
    'applied_no_meter',
    'none',
    'other',
];
var WaterActionInput = function () {
    var _a, _b, _c, _d;
    var trans = context_1.useSemantics().trans;
    var _e = formik_1.useFormikContext(), errors = _e.errors, values = _e.values;
    var action = values.project.watersure.water_action || [];
    return (react_1.default.createElement(__1.FormControl, { errors: ((_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.watersure) === null || _b === void 0 ? void 0 : _b.water_action) || [], label: trans('project:slhh::labels.water-advice-taken'), showOther: action.indexOf(enums_1.BooleanOther.OTHER) > -1, other: react_1.default.createElement(__1.FormControl, { errors: (_d = (_c = errors.project) === null || _c === void 0 ? void 0 : _c.watersure) === null || _d === void 0 ? void 0 : _d.water_action_other, label: trans('project:slhh::labels.water-advice-action-other') },
            react_1.default.createElement(__1.TextArea, { fast: true, name: "project.watersure.water_action_other", maxLength: 2500 })) },
        react_1.default.createElement("div", { className: "flex flex-col" }, options.map(function (key) { return (react_1.default.createElement(__1.Checkbox, { key: "water_action." + key, name: "project.watersure.water_action", label: trans("project:slhh::enum.watersure-action." + key), value: key })); }))));
};
exports.default = WaterActionInput;
//# sourceMappingURL=WaterActionInput.js.map